import { Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

import { useOrderContext } from '@/resources/hooks/useOrderContext';

export function FinishedOrder() {
  const { useFunction } = useOrderContext();
  const toCart = useFunction('backToCart') || (() => {});
  const shouldShowSteps = useFunction('shouldShowSteps') || (() => {});
  return (
    <>
      <div className="card d-flex justify-content-center flex-column align-items-center p-5 gap-4 mt-2">
        <div>
          <FaCheckCircle size="10em" style={{ opacity: 0.2 }} />
        </div>
        <div className="text-center">
          <h2>Compra efetuada com sucesso!</h2>
          <p className="text-muted">Enviaremos seu pedido para nossa equipe de separação!</p>

          <Button
            type="button"
            variant="success"
            onClick={() => {
              shouldShowSteps();
              toCart();
            }}
          >
            Acompanhar pedido
          </Button>
        </div>
      </div>
    </>
  );
}
